export default __webpack_public_path__ + "static/media/BeVietnam-Medium.ba21de51.ttf";